var _sodipodiNamedview, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompozzBoussoleVioletCentreAiguille(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    viewBox: "0 0 114 114",
    sodipodiDocname: "Compozz_boussole_violet_centre_aiguille.svg",
    width: 114,
    height: 114,
    inkscapeVersion: "1.2.2 (b0a8486541, 2022-12-01)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview34",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeZoom: 5.4224638,
    inkscapeCx: 24.896432,
    inkscapeCy: 62.056662,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 1011,
    inkscapeWindowX: 1920,
    inkscapeWindowY: 32,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "Calque_2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .cls-1 {\n        fill: #654bf6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1",
    transform: "translate(0.84786445,0.39328387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.360001,
    cy: 56.900002,
    r: 4.5999999,
    id: "circle20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 42.6,76.83 v 0 C 42.08,76.47 41.92,75.76 42.24,75.21 L 52.43,56.65 c 0.36,-0.61 1.16,-0.79 1.75,-0.39 l 3.55,2.45 c 0.58,0.4 0.7,1.22 0.25,1.77 L 44.24,76.59 c -0.4,0.49 -1.12,0.6 -1.64,0.24 z",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 70.12,36.97 v 0 C 69.6,36.61 68.88,36.71 68.48,37.21 L 54.74,53.32 c -0.45,0.55 -0.33,1.37 0.25,1.77 l 3.55,2.45 c 0.58,0.4 1.39,0.22 1.75,-0.39 L 70.48,38.59 c 0.32,-0.55 0.16,-1.25 -0.36,-1.62 z",
    id: "path24"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompozzBoussoleVioletCentreAiguille);
export default __webpack_public_path__ + "static/media/Compozz_boussole_violet_centre_aiguille.ec7059f1e4c7eacf32c44d69ae69b8ab.svg";
export { ForwardRef as ReactComponent };